<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- alert message -->
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <!-- alert message end -->
    <!-- header -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- header end -->
    <!-- action buttons and search -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-1">
      <v-row class="ma-1">
        <!-- search type -->
        <v-autocomplete
          color="primary"
          class="mr-4"
          v-model="field_type"
          :items="field_item"
          item-value="id"
          style="max-width: 150px;"
          item-title="name"
          label="Select Field"
          variant="outlined"
        ></v-autocomplete>
        <!--search field  -->
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="inward_search"
          v-no-edge-space
          label="Search"
          style="max-width: 300px;"
          variant="outlined"
          color="primary"
          v-on:keyup.enter="loadData()"
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- action buttons -->
        <v-card-actions style="margin-bottom: 18px;">
          <v-btn
            class="ma-2 text-none"
            variant="flat"
            size="x-large" 
            color="primary"
            :disabled="this.selected.length == 0"
            @click="approveItems"
             v-if="isActionAllowed(role)"
            >Approve</v-btn
          >
          <v-btn
            class="ma-2 text-none"
            variant="flat"
            size="x-large" 
            color="primary"
            :disabled="this.selected.length == 0"
            @click="rejectItems"
             v-if="isActionAllowed(role)"
            >Reject</v-btn
          >
          <v-btn
            class="ma-2 text-none"
            variant="flat"
            size="x-large" 
            color="primary"
            :disabled="this.selected.length == 0"
            @click="downloadItems"
             v-if="isActionAllowed(role)"
            >Download</v-btn
          >
        </v-card-actions>
        <!-- filter -->
        <v-expansion-panels
            class="custom-control_outlined m-0 pt-4"
            ref="filterPopupRef"
            readonly
            style="max-width: 300px;"
          >
            <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
              <v-expansion-panel-title
                >Filter
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-row>
    </v-card-title>
    <!-- action buttons and search end -->
    <!-- table  -->
    <v-layout column>
      <v-col md6 style="overflow: auto">
        <v-data-table
          :dense="true"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%"
          :loading="loading"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key !== 'imags' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>

          <!-- <template v-slot:item.supplying_site="{ item }">
            <span>{{ item.supplying_site ? item.supplying_site : "-" }}</span>
          </template>
          <template v-slot:item.serial_number="{ item }">
            <span>{{ item.serial_number ? item.serial_number : "-" }}</span>
          </template>
          <template v-slot:item.supplier_organization="{ item }">
            <span>{{ item.supplier_organization ? item.supplier_organization : "-" }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- table end -->
    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-0 mb-3"
                />
    <!--Approve Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okapproveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex" v-if="action_name == 'success' || action_name == 'deletion_reject'">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approvalConfirmationCancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card class="v-card-100"  v-if="action_name == 'delete' || action_name == 'deletion_approval'">
            <v-card-title>
              <span v-if="action_name == 'deletion_approval'">Remarks</span>
              <span v-if="action_name == 'delete'">Reason For Deletion</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="approvalConfirmationCancel">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text class="text-center">
            <span v-if="action_name == 'success' || action_name == 'deletion_reject'"> {{message}} </span>
            <span v-if="action_name == 'deletion_approval'">
              <v-text-field color="primary" label="Enter the remarks" v-model="deletion_remarks" variant="outlined" class="mt-7"></v-text-field>
            </span>
            <span v-if="action_name == 'delete'">
              <v-text-field color="primary" label="Enter reason for deleting this PRD" v-model="deletion_remarks" variant="outlined" class="mt-7"></v-text-field>
            </span>
          </v-card-text>
          <v-card-actions center v-if="confirmedClicked == false">
            <v-spacer></v-spacer>
            <v-btn :color="action_name != 'deletion_reject' && !deletion_remarks ? 'secondry' : 'primary'" variant="flat" class="mb-3" :disabled="action_name != 'deletion_reject' && !deletion_remarks">Confirm</v-btn>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3" @click="approvalConfirmationCancel">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-card-actions v-if="confirmedClicked">
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3" @click="okClicked">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- filter popup -->
    <v-row justify="center">
      <v-dialog
        content-class="filter-insurance"
        v-model="filterWithSubPopup"
        persistent
        max-width="936px"
      >
        <v-card class="filter_ui">
          <v-card-text class="d-flex align-center px-2">
            <v-row>
              <v-col>
                <v-text-field
                  color="primary"
                  prepend-inner-icon="mdi-magnify"
                  v-model="article_id_search"
                  label="Article Id"
                  style="max-width: 300px;"
                  class="ma-2"
                  variant="outlined"
                  v-on:keyup.enter="loadData()"
                ></v-text-field>
              </v-col>
                <!-- <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  v-model="serial_number_search"
                  label="Serial Number"
                  style="max-width: 300px;"
                  class="ma-2"
                  variant="outlined"
                  v-on:keyup.enter="loadData()"
                ></v-text-field> -->
              <v-col>
                <v-text-field
                  color="primary"
                  prepend-inner-icon="mdi-magnify"
                  v-model="ird_search"
                  label="IRD"
                  style="max-width: 300px;"
                  class="ma-2"
                  variant="outlined"
                  v-on:keyup.enter="loadData()"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-combobox
                  color="primary"
                  prepend-inner-icon="mdi-magnify"
                  v-model="supplier_organization_search"
                  :items="filter_status"
                  item-title="vendor_name"
                  item-value="vendor_code"
                  label="Supplier Organization"
                  style="width: 300px !important;"
                  class="ma-2"
                  variant="outlined"
                  v-on:keyup.enter="loadData()"
                ></v-combobox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="text" color="normal" @click="closeFilterpopup"
              >Cancel</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              class="text-none"
              :color="number > 0 ? 'secondry' : 'primary'"
              @click="applyFilterFunc"
              :disabled="number > 0"
              >Apply Filter(S)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- ird popup -->
    <v-row justify="center">
      <v-dialog v-model="itemPopup" persistent max-width="600px">
        <v-card class="v-card-100 pa-2">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <ul>
              <li v-for="(item, index) in selectedItemsWithExistingIRD" :key="index" class="mb-2">
                <span>
                  <span style="font-weight: bold;">Article ID:</span> {{ item.sku_code }}    
                  <span style="font-weight: bold;">Serial No.:</span> {{ item.serial_number }}   
                  <span style="font-weight: bold;">Belongs to IRD</span> '{{ item.existing_ird }}'</span>
              </li>
            </ul>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn small outlined text color="primary" @click="itemPopup = false">Cancel</v-btn>
            <v-btn small color="primary" @click="confirmContinue">Continue</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- success popup -->
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center">
            <span > {{message}} </span>
          </v-card-text>
          <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mb-3" @click="closePopup">Ok</v-btn>
              <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import { isOnlyViewAction } from '@/backend/axios/moduleAccess'
export default {
  data() {
    return {
      headerText: "Excess Item Details",
      alert: false,
      alert_type: "success",
      alert_message: "success",
      headers: [
        { title: "Article ID", key: "sku_code", sortable: false },
        { title: "Artical Description", key: "sku_description" },
        { title: "Serial Number", key: "serial_number" },
        { title: "IRD", key: "ird_number" },
        { title: "Sending Organization", key: "supplier_organization" },
        { title: "Sending Location", key: "supplying_site" }
      ],
      // viewDetailsHeader: [
      //   { text: "IRD", key: "tag_number", sortable: false },
      //   { text: "Box ID", key: "category" },
      //   { text: "Tag ID", key: "category" },
      //   { text: "Article ID", key: "mrp" },
      //   { text: "Article Description", key: "mrp" },
      //   { text: "Qty", key: "mrp" },
      // ],
      inward_search: "",
      article_id_search: "",
      serial_number_search: "",
      ird_search: "",
      supplier_organization_search: [],
      filterWithSubPopup: false,
      message : '',
      okapproveconfirmpopup : false,
      confirmedClicked : false,
      action_name : '',
      prd_number: '',
      field_type: [],
      field_item: [],
      filter_status: [],
      selected: [],
      search: "",
      table_data: [],
      loading: false,
      page: 1,
      totalPages: [],
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      number: 0,
      deletion_remarks : '',
      successPopup : false,
      itemPopup : false,
      selectedItemsWithExistingIRD :'',
      role:'',
    };
  },
  components: {
    HeaderComponent
  },
  created() {
    this.loadData();
    this.role = this.$store.state.currentUser.roles[0]

  },
  methods: {
    isActionAllowed(){
      return !isOnlyViewAction(this.role, 'Inwarding')
    },
    loadData() {
      // this.inward_search = "";
      // this.field_type = "";
      this.table_data = [];
      this.page = 1;
      this.totalPages = 1;
      this.selected = [];
      this.getTabData();
    },
    getTabData() {
      const requestBody = {
        search: this.inward_search,
        search_in: this.field_type,
        page: this.page,
        per_page: this.pageSize
      };
      this.$http?.secured
        .get("/api/v1/warehouse/excess_items?", { params: requestBody })
        .then(response => {
          if (response.data.excess_items) {
            this.table_data = response.data.excess_items;
            this.totalPages = response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filterWithSubPopup = false;
            this.filterItems();
            this.loading = false;
            this.field_type = '';
            this.inward_search = '';
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    filterListOfButtons() {
      this.inward_search = "";
      document.documentElement.style.setProperty("--dialog-ypos",(this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + "px");
      this.filterWithSubPopup = true;
    },

    applyFilterFunc() {
      const params = new URLSearchParams();
      params.append("sku_code", this.article_id_search);
      params.append("serial_number", this.serial_number_search);
      params.append("ird_number", this.ird_search);
      params.append("supplier_organization", this.supplier_organization_search.vendor_code || "");
      const pageparams = this.getRequestParams(this.page, this.pageSize);
      params.append("page", pageparams["page"]);
      params.append("per_page", pageparams["size"]);

      this.$http?.secured
        .get("/api/v1/warehouse/excess_items?", { params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.pending_receipt_document_items;
            this.totalPages = response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filterWithSubPopup = false;
            this.article_id_search = "";
            this.serial_number_search = "";
            this.ird_search = "";
            this.supplier_organization_search = [];
            // this.menu_171 = false
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },

    closeFilterpopup() {
      this.filterWithSubPopup = false;
      this.article_id_search = "";
      this.serial_number_search = "";
      this.ird_search = "";
      this.supplier_organization_search = [];
    },

    filterItems() {
      // document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      // this.addColoumns.show = false;
      this.$httpSecured
        .get("/api/v1/warehouse/excess_items/filters_data")
        .then(response => {
          this.field_item = response.data.search_fields;
          this.filter_status = response.data.supplier_organizations;
        });
    },

    approveItems() {
      const selectedId = this.selected.map(item => item.id);
      let search_param = {
          ids: selectedId
      };
      const hasExistingIRD = this.selected.some(item => item.existing_ird !== null && item.existing_ird !== '');
      if (hasExistingIRD) {
          this.itemPopup = true;
          this.selectedItemsWithExistingIRD = this.selected.filter(item => item.existing_ird !== null && item.existing_ird !== '');
      } else {
        this.$httpSecured
          .post("/api/v1/warehouse/excess_items/approve", search_param)
          .then(response => {
              if (response.data) {
                  this.successPopup = true;
                  this.message = response.data.message;
                  this.loading = false;
                  this.getTabData();
                  this.selected = [];
              } else {
                  this.showAlert("error", "No Data Found");
                  this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.loading = false;
          });
      }
    },
    approvalConfirmationCancel(){
      this.okapproveconfirmpopup = false
    },
    rejectItems() {
      const selectedId = this.selected.map(item => item.id);
      if (this.selected.length > 0) {
        let search_param = {
          ids: selectedId
        };
        this.$httpSecured
          .post("/api/v1/warehouse/excess_items/reject", search_param)
          .then(response => {
            if (response.data) {
              this.successPopup = true;
              this.message = response.data.message;
              this.loading = false;
              this.getTabData();
              this.selected = [];
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.loading = false;
          });
        }
    },
    
    downloadItems() {
      const selectedId = this.selected.map(item => item.id);
      if (this.selected.length > 0) {
        let download_param = {
          ids: selectedId
        };
        this.$httpSecured
          .get("/api/v1/warehouse/excess_items/download_items", {
            params: download_param
          })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `excess-item-details.csv`);
            document.body.appendChild(link);
            link.click();
            this.message = "CSV for prd ( ";
            for( var i=0;i<Math.min(this.selected.length,3); i++){
                if( i==0){
                    this.message += this.selected[i].prd_number
                } else {
                    this.message +=", " + this.selected[i].prd_number
                }
            }
            if(this.selected.length>3){
                this.message +=",... "
            }
            this.message+=" ) Successfully Downloaded.";
            this.okapproveconfirmpopup = true;
            this.action_name = 'success';
            this.confirmedClicked = true;
            this.selected = [];
          })
          .catch(error => 
            this.showAlert("error", "Error in fetching pending GRN inventories")
          );
      } else {
        this.$toast.error("Atleast one RRN should be selected");
      }
    },

    okClicked(){
      this.okapproveconfirmpopup = false;
      this.confirmedClicked = false;
      this.getTabData();
    },
    confirmContinue (){
      const selectedId = this.selected.map(item => item.id);
      let search_param = {
          ids: selectedId
      };
      this.$httpSecured
        .post("/api/v1/warehouse/excess_items/approve", search_param)
        .then(response => {
          if (response.data) {
            this.successPopup = true;
            this.message = response.data.message;
            this.loading = false;
            this.getTabData();
            this.selected = [];
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
          }
        })
        .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
            this.itemPopup = false
            this.selected = []
        });
    },
    closePopup (){
      this.successPopup = false
      this.itemPopup = false
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },

    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    // To handle the page change
    handlePageChange(value) {
      this.page = value;
      this.getTabData()
    },
    //  To handle the page size change
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1
      this.getTabData()
    },
  }
};
</script>
<style scoped>
.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}

.v-dialog:has(.filter-insurance) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
.item-selected{
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 313px) !important;
}
.filter_ui{
    margin-left: 8px !important;
 } 
</style>
